import { createFileRoute } from '@tanstack/react-router';
import AuthenticateRoute from 'src/components/organisms/app-layouts/authenticate-route/authenticate-route';
import { PropertyPublicationsPage } from 'src/modules/catalog/components/pages/property-publications.page';
import {
  propertyPublicationsSearchSchema,
  toPropertiesBackSearch,
} from 'src/modules/catalog/schemas/property-publications-search.schema';

export const Route = createFileRoute('/catalog/properties/publications')({
  component: CatalogPropertiesPublicationsComponent,
  validateSearch: (search) => propertyPublicationsSearchSchema.parse(search),
});

function CatalogPropertiesPublicationsComponent() {
  const search = Route.useSearch();

  return (
    <AuthenticateRoute>
      <PropertyPublicationsPage
        search={search}
        backSearch={toPropertiesBackSearch(search)}
      />
    </AuthenticateRoute>
  );
}

export default Route;
